import React from "react"
import "../styles/Contacts.css"

export default function Contacts(){


	return (<>

			<div id="info">

			<div class='name-job'>

			<h2>Zachery H.Wilson</h2>
			<h3>REAL ESTATE AGENT</h3>

			</div>

			<div className="contacts">

				<div>OFFICE: (876) 444-6969</div>
				<div>FAX:    (876) 555-2304</div>
				<div>DIRECT: (876) 834-5629</div>


			</div>


			<div class="websites">

				<div>ZHWilson@AKWilliamsReality.com</div>
				
				

			</div>

			
			</div>

				</>)
} 